// extracted by mini-css-extract-plugin
export default {"wrapper":"_8e950454","subHeader":"_6e76ddfc","swiperList":"_87ac5fcf"};